import { RouteObject } from "react-router-dom";
import WelcomePage from "../pages/welcomePage";
import { DomainProvider } from "@4uhub/lib4uhub";
import AutomationRulePage from "../pages/4uESign/Automations/AutomationRules/AutomationRulesPage";
import AutomationRule from "../pages/4uESign/Automations/AutomationRules/AutomationRuleForm/AutomationRuleForm";
import ForubusSignature from "../pages/4uESign/Logs/ForubusSignature/ForubusSignature";
import AutomationRuleGroupsPage from "../pages/4uESign/Automations/AutomationRuleGroups/AutomationRuleGroupsPage";
import AutomationRuleGroupForm from "../pages/4uESign/Automations/AutomationRuleGroups/AutomationRuleGroupForm";
import EmailSendRulesPage from "../pages/4uESign/Automations/EmailSendRules/EmailSendRulesPage";
import EmailSendRuleForm from "../pages/4uESign/Automations/EmailSendRules/EmailSendRuleForm";

const esign: RouteObject[] = [
  {
    index: true,
    element: <WelcomePage />,
  },
  {
    path: "createAutomations/automationRules",
    element: (
      <DomainProvider value={{ domainName: "esignrule" }}>
        <AutomationRulePage />
      </DomainProvider>
    ),
  },
  {
    path: "createAutomations/automationRules/new",
    element: (
      <DomainProvider value={{ domainName: "esignrule" }} actions={["Create"]}>
        <AutomationRule />
      </DomainProvider>
    ),
  },
  {
    path: "createAutomations/automationRules/:id/edit",
    element: (
      <DomainProvider value={{ domainName: "esignrule" }}>
        <AutomationRule />
      </DomainProvider>
    ),
  },
  {
    path: "createAutomations/signatureGroups",
    element: (
      <DomainProvider value={{ domainName: "esignrule" }}>
        <AutomationRuleGroupsPage />
      </DomainProvider>
    ),
  },
  {
    path: "createAutomations/signatureGroups/:id/edit",
    element: (
      <DomainProvider value={{ domainName: "esignrule" }} actions={["Update"]}>
        <AutomationRuleGroupForm />
      </DomainProvider>
    ),
  },
  {
    path: "createAutomations/emailSendRules",
    element: (
      <DomainProvider value={{ domainName: "esignemailsendrule" }}>
        <EmailSendRulesPage />
      </DomainProvider>
    ),
  },
  {
    path: "createAutomations/emailSendRules/new",
    element: (
      <DomainProvider
        value={{ domainName: "esignemailsendrule" }}
        actions={["Create"]}
      >
        <EmailSendRuleForm />
      </DomainProvider>
    ),
  },
  {
    path: "createAutomations/emailSendRules/:id/edit",
    element: (
      <DomainProvider value={{ domainName: "esignemailsendrule" }}>
        <EmailSendRuleForm />
      </DomainProvider>
    ),
  },
  {
    path: "logs/forubusSignatureLogs",
    element: (
      <DomainProvider value={{ domainName: "forubussignaturelog" }}>
        <ForubusSignature />
      </DomainProvider>
    ),
  },
];

export default esign;
